import axios from 'axios'
import { Notification } from 'element-ui'
import Cookies from 'js-cookie'
import { notFoundPageCodes,HttpCode ,HttpUrl} from '@/utils/setting'
import router from '@/router'
import qs from 'qs'
import store from '@/store'
import {SuperTask} from '@/utils'
import {getToken,getRefreshToken} from '@/utils/auth'

// 创建axios实例
const service = axios.create({

  // baseURL: process.env.VUE_APP_BASE_API
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/' // api 的 base_url

})

// function generateReqKey(config) {
//   const { method, url, params, data } = config

//   return [method, url, qs.stringify(params), qs.stringify(data)].join('&')
// }

// const pendingRequest = new Map()

// function addPendingRequest(config) {
//   const requestKey = generateReqKey(config)
//   config.canccelToken = config.cancelToken || new axios.CancelToken((cancel) => {
//     if (!pendingRequest.has(requestKey)) {
//       pendingRequest.set(requestKey, cancel)
//     }
//   })
// }

// function removePendingRequest(config) {
//   const requestKey = generateReqKey(config)
//   if (pendingRequest.has(requestKey)) {
//     const cancelToken = pendingRequest.get(requestKey)
//     cancelToken(requestKey)
//     pendingRequest.delete(requestKey)
//   }
// }

let sendTime = 0 // 接口发送时间
let endTime = 0 // 接口结束时间
let superTask = new SuperTask()

// request拦截器
service.interceptors.request.use(
  config => {
    sendTime = new Date().getTime()

    config.headers['Authorization'] = getToken()
    config.headers['Site-Id'] = Cookies.get('siteId')
    config.headers['Site-Host'] = Cookies.get('domain') || location.host
    // config.headers['Content-Type'] = 'application/json'

    config.cancelToken = new axios.CancelToken(function executor(c) {
      store.state.app.cancelTokens.push(c)
    })

    // removePendingRequest(config) // 检查是否存在重复请求
    // addPendingRequest(config) // 将当前请求信息添加到 pendingRequest对象中

    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    endTime = new Date().getTime()
    // removePendingRequest(response.config) // 从 pendingRequest对象中移除请求
    // response.data.reqTime = endTime - sendTime

    return response.data // #my
  },
  async error => {
    // removePendingRequest(error.config || {}) // 从 pendingRequest对象中移除请求
    if (notFoundPageCodes.includes(error.response?.data?.code)) {
      // 触发notFoundPageCodes状态码时统一跳404页
      router.push('/404')
      return
    }
    // 请求成功，但是登录过期301
    if(error.response?.data?.code === HttpCode.NOLOGIN){
      // 刷新token也过期
      // if(error.response.config?.url === HttpUrl.USER_REFRESH){
      Notification.error({
        title: error.response.data.message,
        duration: 5000
      })
      store.dispatch('user/doLogout','/')
      // }
      // 刷新token
      // await store.dispatch('user/doRefreshToken').then(async()=>{
      //   console.log('刷新token成功（301触发）')
      //   await service(error.response.config)  // 重试当前请求
      // })
      return Promise.reject(error)
    }
    if (error.response?.data?.message && !error.response.config?.headers?.noPrint) {
      Notification.error({
        title: error.response.data.message,
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)

export default service
